module.exports = __webpack_public_path__ + "img/img5.2e40decc.svg";